export const carVerticalName = 'car-insurance';
export const homecontentVerticalName = 'home-contents-insurance';

export const whitelabelBrandcodes = {
    CTM: 'ctm',
    CHOO: 'choo',
    ISLT: 'islt',
    LOCAL: 'local'
};

export const carBrandcodes = {
    BUDD: 'BUDD',
    EXOA: 'EXOA',
    EXIG: 'EXIG',
    HUDD: 'HUDD',
    OZIC: 'OZIC',
    VIRG: 'VIRG',
    WOOL: 'WOOL',
    CARP: 'CARP',
    PROG: 'PROG',
    BUPA: 'BUPA',
    AHM: 'AHM',
    EXCL: 'EXCL',
    STEL: 'STEL'
};

export const homecontentsBrandcodes = {
    BUDD: 'BUDD',
    VIRG: 'VIRG',
    WOOL: 'WOOL',
    HUDD: 'HUDD',
    CHU: 'CHU',
    HONY: 'HONY',
    EXIG: 'EXIG',
    HBOQ: 'HBOQ',
    BUPA: 'BUPA',
    AHM: 'AHM',
    EXCL: 'EXCL'
};
